import { jsx as _jsx } from "react/jsx-runtime";
import "../../../assets/css/vendors/toastify.css";
import { useRef, createRef, useEffect } from "react";
import { init, reInit } from "./notification";
import clsx from "clsx";
function Notification({ className = "", options = {}, getRef = () => { }, children, ...computedProps }) {
    const props = {
        className: className,
        options: options,
        getRef: getRef,
    };
    const initialRender = useRef(true);
    const toastifyRef = createRef();
    useEffect(() => {
        if (toastifyRef.current) {
            if (initialRender.current) {
                props.getRef(toastifyRef.current);
                init(toastifyRef.current, props);
                initialRender.current = false;
            }
            else {
                reInit(toastifyRef.current);
            }
        }
    }, [props.options, children]);
    return (_jsx("div", { ...computedProps, className: clsx([
            "py-5 pl-5 pr-14 bg-white border border-slate-200/60 rounded-lg shadow-xl dark:bg-darkmode-600 dark:text-slate-300 dark:border-darkmode-600 hidden",
            props.className,
        ]), ref: toastifyRef, children: children }));
}
export default Notification;